import { render, staticRenderFns } from "./MappingCategoryComboBox.vue?vue&type=template&id=53a9aefa&scoped=true"
import script from "./MappingCategoryComboBox.vue?vue&type=script&lang=ts"
export * from "./MappingCategoryComboBox.vue?vue&type=script&lang=ts"
import style0 from "./MappingCategoryComboBox.vue?vue&type=style&index=0&id=53a9aefa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a9aefa",
  null
  
)

export default component.exports